import React from "react";
import { Link } from "react-router-dom";

const PathfinderHome = () => {
  return (
    <div>
      <h1>Pathfinder Tools</h1>
      <ul>
        <li>
          <Link to="/pathfinder/primal-spells">Primal Spells</Link>
        </li>
        <li>
          <Link to="/pathfinder/summon-animals">Summon Animals</Link>
        </li>
        <li>
          <Link to="/pathfinder/qftff">
            Quest For the Frozen Flame Encounters
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default PathfinderHome;
